import { CustomStep } from "../warehouseJoyrideSteps";
import JoyrideTooltip from "../../JoyrideTooltip/JoyrideTooltip";
import JoyrideTooltipContentWrapper from "../components/JoyrideTooltipContentWrapper";
import SimpleContentStep from "../StepsComponents/SimpleContentStep";
import React from "react";
import CreateProductFormStep from "../StepsComponents/CreateProductFormStep";
import WarehouseSelectionStep from "../StepsComponents/WarehouseSelectionStep";
import AddProductToWarehouseFormStep from "../StepsComponents/AddProductToWarehouseFormStep";
import TutorialTransStep from "../StepsComponents/TutorialTransStep";
import SaleProductFormStep from "../StepsComponents/SaleProductFormStep";

export const getProductSalesConfigArray = (
    branchId: string,
    hasProducts?: boolean,
    goNext?: () => void
): CustomStep[] => {
    const windowWidth = window?.innerWidth;

    return [
        // step 0
        {
            target: "[data-tour='create-product-btn']",
            content: (
                <JoyrideTooltip>
                    <JoyrideTooltipContentWrapper
                        hasProducts={hasProducts}
                        skipCreateProductRout={`/warehouses/branch/${branchId}`}
                    >
                        <SimpleContentStep text='Click the "Add product" button' fw="bold" />
                    </JoyrideTooltipContentWrapper>
                </JoyrideTooltip>
            ),
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
            placement: "bottom",
        },
        // step 1
        {
            target: "[data-tour='create-product-form']",
            content: (
                <JoyrideTooltip>
                    <JoyrideTooltipContentWrapper>
                        <CreateProductFormStep />
                    </JoyrideTooltipContentWrapper>
                </JoyrideTooltip>
            ),
            placement: windowWidth > 1780 ? "left" : "top",
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
            isFixed: true,
            observeResize: true,
            pageScrollReposition: true,
            disableScrollParentFix: false,
        },
        // step 2
        {
            target: "[data-tour='product-created']",
            content: (
                <JoyrideTooltip>
                    <JoyrideTooltipContentWrapper showNext route={`/warehouses/branch/${branchId}`}>
                        <SimpleContentStep text="The product has been created!" fw="bold" />
                    </JoyrideTooltipContentWrapper>
                </JoyrideTooltip>
            ),
            placement: "bottom",
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
            spotlightClicks: false,
        },
        // step 3
        {
            target: "[data-tour='warehouse-selection']",
            content: (
                <JoyrideTooltip>
                    <JoyrideTooltipContentWrapper>
                        <WarehouseSelectionStep />
                    </JoyrideTooltipContentWrapper>
                </JoyrideTooltip>
            ),

            floaterProps: {
                placement: windowWidth > 1780 ? "left-start" : "top",
                disableFlip: true,
            },
            placement: windowWidth > 1780 ? "left-start" : "top",
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
        },
        // step 4
        {
            target: "[data-tour='add-products-to-warehouse-btn']",
            content: (
                <JoyrideTooltip>
                    <JoyrideTooltipContentWrapper>
                        <SimpleContentStep text='Click "Add product to warehouse"' fw="bold" />
                    </JoyrideTooltipContentWrapper>
                </JoyrideTooltip>
            ),
            placement: "bottom",
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
        },
        // step 5
        {
            target: "[data-tour='add-product']",
            content: (
                <JoyrideTooltip>
                    <JoyrideTooltipContentWrapper>
                        <SimpleContentStep text='Click "+" to add' fw="bold" />
                    </JoyrideTooltipContentWrapper>
                </JoyrideTooltip>
            ),
            placement: "bottom",
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
        },
        // step 6
        {
            target: "[data-tour='add-product-to-warehouse-form']",
            content: (
                <JoyrideTooltip>
                    <JoyrideTooltipContentWrapper>
                        <AddProductToWarehouseFormStep />
                    </JoyrideTooltipContentWrapper>
                </JoyrideTooltip>
            ),
            placement: windowWidth > 1650 ? "left" : "top",
            floaterProps: {
                placement: windowWidth > 1650 ? "left" : "top",
                disableFlip: false,
            },
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
            spotlightPadding: 0,
            disableScrollParentFix: false,
            pageScrollReposition: true,
            observeResize: true,
            headroomRules: [{ maxW: 1650, top: 170, bottom: 160 }],
            styles: {
                options: {
                    zIndex: 1200,
                    overlayColor: "rgba(0, 0, 0, 0)",
                },
            },
        },
        // step 7
        {
            target: "[data-tour='added-product-to-warehouse']",
            content: (
                <JoyrideTooltip>
                    <JoyrideTooltipContentWrapper showNext route={`/warehouses/branch/${branchId}`}>
                        <SimpleContentStep text="Your product is now in stock!" />
                    </JoyrideTooltipContentWrapper>
                </JoyrideTooltip>
            ),
            placement: windowWidth > 1650 ? "left" : "bottom",
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
            spotlightClicks: false,
        },
        // step 8
        {
            target: "[data-tour='sale-products-btn']",
            content: (
                <JoyrideTooltip>
                    <JoyrideTooltipContentWrapper>
                        <SimpleContentStep text='Click the "Sell Products" button' fw="bold" />
                    </JoyrideTooltipContentWrapper>
                </JoyrideTooltip>
            ),
            placement: "bottom",
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
            spotlightPadding: 6,
        },
        // step 9
        {
            target: "[data-tour='sale-product-form']",
            headroomTarget: ".sale-product-modal",
            content: (
                <JoyrideTooltip>
                    <JoyrideTooltipContentWrapper>
                        <SaleProductFormStep />
                    </JoyrideTooltipContentWrapper>
                </JoyrideTooltip>
            ),
            placement: windowWidth > 1910 ? "left" : "top",
            floaterProps: {
                placement: windowWidth > 1910 ? "left" : "top",
                disableFlip: false,
            },
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
            spotlightPadding: 0,
            disableScrollParentFix: false,
            observeResize: true,
            headroomRules: [{ maxW: 1910, top: 450, bottom: 400 }],
            styles: {
                options: {
                    zIndex: 960,
                    overlayColor: "rgba(0, 0, 0, 0)",
                },
            },
        },
        // step 10
        {
            target: "[data-tour='screenshot-modal']",
            content: (
                <JoyrideTooltip>
                    <JoyrideTooltipContentWrapper showNext goNextId="screenshot-modal-handler">
                        <SimpleContentStep text="Products can be sold directly from the customer's service registration page. Customer data is automatically pulled in. The sale will be associated with this customer visit." />
                    </JoyrideTooltipContentWrapper>
                </JoyrideTooltip>
            ),
            placement: windowWidth > 1900 ? "left" : "top",
            floaterProps: {
                placement: windowWidth > 1900 ? "left" : "top",
                disableFlip: false,
            },
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
            spotlightPadding: 0,
            disableScrollParentFix: false,
            pageScrollReposition: false,
            observeResize: true,
            styles: {
                options: {
                    zIndex: 960,
                    overlayColor: "rgba(0, 0, 0, 0)",
                },
            },
        },
        // step 11
        {
            target: "[data-tour='warehouse-operations-btn']",
            content: (
                <JoyrideTooltip>
                    <JoyrideTooltipContentWrapper>
                        <TutorialTransStep translationKey="warehouseOperationsBtn" />
                    </JoyrideTooltipContentWrapper>
                </JoyrideTooltip>
            ),
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
            placement: "bottom",
        },
        // step 12
        {
            target: "[data-tour='edit-operation-btn']",
            content: (
                <JoyrideTooltip>
                    <JoyrideTooltipContentWrapper>
                        <TutorialTransStep translationKey="editOperationBtn" />
                    </JoyrideTooltipContentWrapper>
                </JoyrideTooltip>
            ),
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
            placement: "bottom",
            spotlightPadding: 6,
        },
        // step 13
        {
            target: "[data-tour='edit-operation-form']",
            headroomTarget: ".sale-product-modal",
            content: (
                <JoyrideTooltip>
                    <JoyrideTooltipContentWrapper showNext goNextId="edit-operation-modal-handler">
                        <TutorialTransStep
                            translationKey="editSaleOperationForm"
                            icon={
                                <span>
                                    {" "}
                                    (<span className="text-danger">*</span>){" "}
                                </span>
                            }
                        />
                    </JoyrideTooltipContentWrapper>
                </JoyrideTooltip>
            ),
            placement: windowWidth > 1910 ? "left" : "top",
            isFixed: true,
            floaterProps: {
                placement: windowWidth > 1910 ? "left" : "top",
                disableFlip: false,
            },
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
            spotlightPadding: 0,
            disableScrollParentFix: false,
            observeResize: true,
            headroomRules: [{ maxW: 1910, top: 320, bottom: 320 }],
            styles: {
                options: {
                    zIndex: 960,
                    overlayColor: "rgba(0, 0, 0, 0)",
                },
            },
        },
        // step 14
        {
            target: "[data-tour='history-operation-btn']",
            content: (
                <JoyrideTooltip>
                    <JoyrideTooltipContentWrapper>
                        <TutorialTransStep translationKey="historyOperationBtn" />
                    </JoyrideTooltipContentWrapper>
                </JoyrideTooltip>
            ),
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
            placement: "bottom",
            spotlightPadding: 6,
        },
        // step 15
        {
            target: "[data-tour='history-operation']",
            content: (
                <JoyrideTooltip>
                    <JoyrideTooltipContentWrapper showNext goNext={goNext}>
                        <SimpleContentStep text="Here you can view the history of changes to the operation." />
                    </JoyrideTooltipContentWrapper>
                </JoyrideTooltip>
            ),
            placement: windowWidth > 1910 ? "left" : "bottom",
            floaterProps: {
                placement: windowWidth > 1910 ? "left" : "bottom",
                disableFlip: false,
            },
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
            spotlightClicks: false,
            observeResize: true,
        },
        // step 16
        {
            target: "[data-tour='screenshot-modal']",
            headroomTarget: ".screenshot",
            content: (
                <JoyrideTooltip>
                    <JoyrideTooltipContentWrapper showNext goNext={goNext}>
                        <SimpleContentStep text="Here you can view sales for each product over a certain period of time." />
                    </JoyrideTooltipContentWrapper>
                </JoyrideTooltip>
            ),
            placement: windowWidth > 1900 ? "left" : "top",
            floaterProps: {
                placement: windowWidth > 1900 ? "left" : "top",
                disableFlip: false,
            },
            isFixed: false,
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
            spotlightPadding: 0,
            disableScrollParentFix: false,
            pageScrollReposition: true,
            observeResize: true,
            styles: {
                options: {
                    zIndex: 960,
                    overlayColor: "rgba(0, 0, 0, 0)",
                },
            },
        },
        // step 17
        {
            target: "[data-tour='screenshot-modal']",
            headroomTarget: ".screenshot",
            content: (
                <JoyrideTooltip>
                    <JoyrideTooltipContentWrapper showNext goNext={goNext}>
                        <TutorialTransStep translationKey="statisticScreenShot17" />
                    </JoyrideTooltipContentWrapper>
                </JoyrideTooltip>
            ),
            placement: windowWidth > 1900 ? "left" : "top",
            floaterProps: {
                placement: windowWidth > 1900 ? "left" : "top",
                disableFlip: false,
            },
            isFixed: false,
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
            spotlightPadding: 0,
            disableScrollParentFix: false,
            pageScrollReposition: true,
            observeResize: true,
            styles: {
                options: {
                    zIndex: 960,
                    overlayColor: "rgba(0, 0, 0, 0)",
                },
            },
        },
        // step 18
        {
            target: "[data-tour='screenshot-modal']",
            headroomTarget: ".screenshot",
            content: (
                <JoyrideTooltip>
                    <JoyrideTooltipContentWrapper showNext goNext={goNext}>
                        <TutorialTransStep translationKey="statisticScreenShot18" />
                    </JoyrideTooltipContentWrapper>
                </JoyrideTooltip>
            ),
            placement: windowWidth > 1900 ? "left" : "top",
            floaterProps: {
                placement: windowWidth > 1900 ? "left" : "top",
                disableFlip: false,
            },
            isFixed: false,
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
            spotlightPadding: 0,
            disableScrollParentFix: false,
            pageScrollReposition: true,
            observeResize: true,
            styles: {
                options: {
                    zIndex: 960,
                    overlayColor: "rgba(0, 0, 0, 0)",
                },
            },
        },
        // step 19
        {
            target: "[data-tour='screenshot-modal']",
            headroomTarget: ".screenshot",
            content: (
                <JoyrideTooltip>
                    <JoyrideTooltipContentWrapper btnNextTutorial={"Finish"}>
                        <TutorialTransStep translationKey="statisticScreenShot19" />
                    </JoyrideTooltipContentWrapper>
                </JoyrideTooltip>
            ),
            placement: windowWidth > 1900 ? "left" : "top",
            floaterProps: {
                placement: windowWidth > 1900 ? "left" : "top",
                disableFlip: false,
            },
            isFixed: false,
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
            spotlightPadding: 0,
            disableScrollParentFix: false,
            pageScrollReposition: true,
            observeResize: true,
            styles: {
                options: {
                    zIndex: 960,
                    overlayColor: "rgba(0, 0, 0, 0)",
                },
            },
        },
    ];
};
